import type React from "react";

import { cn } from "@/lib/utils";

/**
 * Pile de tuiles en perspective, avec l'icône posée sur la tuile de devant.
 *
 * Reprend le motif `@reui/icon-stack` sans tirer le registre reui ni
 * `@tabler/icons-react` : le composant est purement décoratif, l'écrire ici
 * coûte moins qu'une dépendance de plus.
 *
 * Les tuiles arrière sont en `aria-hidden` et l'icône passée en enfant porte le
 * sens — le composant ne doit jamais être le seul véhicule d'une information.
 */
export function IconStack({
  className,
  children,
  ...props
}: React.ComponentProps<"div"> & { children: React.ReactNode }) {
  return (
    <div className={cn("relative flex items-center justify-center", className)} {...props}>
      {/* Tuiles arrière : décalées et amincies pour suggérer la profondeur. */}
      <span
        aria-hidden
        className="absolute h-10 w-10 -translate-y-3 rounded-xl border border-border/60 bg-muted/40 opacity-40"
      />
      <span
        aria-hidden
        className="absolute h-11 w-11 -translate-y-1.5 rounded-xl border border-border/70 bg-muted/60 opacity-70"
      />
      {/* Tuile de devant : porte l'icône. */}
      <span className="relative flex h-12 w-12 items-center justify-center rounded-xl border border-border bg-background shadow-sm">
        {children}
      </span>
    </div>
  );
}
